 
const newModel = () => {
    return {
        nguonvonDautuId: null,
        sttBaocao: null, 
        ten: null, 
        moTa: null, 
        nguonvonDautuChaId: null, 
        tenNguonvonDautuCha: null, 
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        nguonvonDautuId: null,
        sttBaocao: null, 
        ten: null, 
        moTa: null, 
        nguonvonDautuChaId: null, 
        stt: "0",
        enabled: true,
    }
}
             
const fromJson = (item) => {
    return {
        nguonvonDautuId: item.nguonvonDautuId,   
        sttBaocao: item.sttBaocao, 
        ten: item.ten, 
        moTa: item.moTa, 
        nguonvonDautuChaId: item.nguonvonDautuChaId, 
        tenNguonvonDautuCha: item.tenNguonvonDautuCha, 
        stt: item.stt, 
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        nguonvonDautuId: item.nguonvonDautuId,   
        sttBaocao: item.sttBaocao, 
        ten: item.ten, 
        moTa: item.moTa, 
        nguonvonDautuChaId: item.nguonvonDautuChaId, 
        stt: item.stt, 
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        nguonvonDautuChaId: null, 
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        nguonvonDautuChaId: item.nguonvonDautuChaId, 
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        nguonvonDautuId: null,
        sttBaocao: null, 
        ten: null, 
        moTa: null, 
        nguonvonDautuChaId: null, 
        stt: null,
        enabled: null,
    }
}

export const nguonvonDautuModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


